/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Kit 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Navbar.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `name` key is used for the name of the route on the Navbar.
  2. The `icon` key is used for the icon of the route on the Navbar.
  3. The `collapse` key is used for making a collapsible item on the Navbar that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  4. The `route` key is used to store the route location which is used for the react router.
  5. The `href` key is used to store the external links location.
  6. The `component` key is used to store the component of its route.
  7. The `dropdown` key is used to define that the item should open a dropdown for its collapse items .
  8. The `description` key is used to define the description of
          a route under its name.
  9. The `columns` key is used to define that how the content should look inside the dropdown menu as columns,
          you can set the columns amount based on this key.
  10. The `rowsPerColumn` key is used to define that how many rows should be in a column.
*/

// @mui material components
import Icon from "@mui/material/Icon";
//import LanguageIcon from "@mui/icons-material/Language";
// @mui icons
//import GitHubIcon from "@mui/icons-material/Admin";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
//import LocationCityRounded from "@mui/icons-material/LocationCityRounded";
import Scale from "@mui/icons-material/Scale";
import PersonIcon from "@mui/icons-material/Person";
import StrategyIcon from "@mui/icons-material/TrendingUp";
// Pages
import React from "react";
// Sections
//import PageHeaders from "layouts/sections/page-sections/page-headers";
//import Features from "layouts/sections/page-sections/featuers";
import Navbars from "layouts/sections/navigation/navbars";
import NavTabs from "layouts/sections/navigation/nav-tabs";
import Pagination from "layouts/sections/navigation/pagination";
import Meetings from "components/Meetings";
import Organs from "components/Organs";
//import Municipalities from "components/Municipalities";
import Strategy from "components/Strategy";
import Minutes from "components/Minutes";
import Profile from "components/Profile";
import Initiatives from "components/Initiatives";
//import Muniadmin from "components/Muniadmin";

//import { useTranslation } from "react-i18next";
//const [t] = useTranslation("common");
//t("welcome.title")
const routes = [
  {
    name: "Päätöksenteko",
    icon: <Scale />,
    dropdown: true,
    collapse: [
      {
        name: "Toimielimet",
        description: "kunnan toimielimet",
        route: "/organs",
        component: <Organs />,
      },
      {
        name: "Kokoukset",
        icon: <Icon>view_day</Icon>,
        description: "toimielinten kokoukset",
        route: "/meetings",
        component: <Meetings />,
      },
      {
        name: "Pöytäkirjat",
        icon: <Icon>view_day</Icon>,
        description: "kokousten pöytäkirjat",
        route: "/minutes",
        component: <Minutes />,
      },
    ],
  },
  {
    name: "Kuntastrategia",
    icon: <StrategyIcon />,
    description: "Osallistu valmisteluun",
    route: "/strategy",
    component: <Strategy />,
  },
  {
    name: "Aloitteet",
    icon: <Icon>article</Icon>,
    description: "tarkastele luotuja aloitteita",
    route: "/initiatives",
    component: <Initiatives />,
  },
  {
    name: "Käyttäjätili",
    icon: <PersonIcon />,
    description: "käyttäjän tiedot",
    route: "/profile",
    component: <Profile />,
  },
  {
    name: "Admin",
    icon: <AdminPanelSettingsIcon />,
    dropdown: true,
    collapse: [
      {
        name: "Agendas scraping",
        route: "/scraping",
        component: <Navbars />,
      },
      {
        name: "Minutes scraping",
        route: "/minutesscraping",
        component: <NavTabs />,
      },
      {
        name: "Minutes",
        route: "/minutesadmin",
        component: <Pagination />,
      },
      {
        name: "Users",
        route: "/usersadmin",
        component: <Pagination />,
      },
      {
        name: "Organs",
        route: "/organsadmin",
        component: <Pagination />,
      },
      {
        name: "Meetings",
        route: "/meetingsadmin",
        component: <Pagination />,
      },
      {
        name: "Comments",
        route: "/commentsadmin",
        component: <Pagination />,
      },
      {
        name: "Initiatives",
        route: "/initiativesadmin",
        component: <Pagination />,
      },
      {
        name: "Proposals",
        route: "/proposalsadmin",
        component: <Pagination />,
      },
      {
        name: "Links",
        route: "/linksadmin",
        component: <Pagination />,
      },
      {
        name: "Cases",
        route: "/sectionsadmin",
        component: <Pagination />,
      },
      {
        name: "Kunnan asetukset",
        route: "/muniadmin",
        component: <Pagination />,
      },
      {
        name: "Strategycomments",
        route: "/strategycommentsadmin",
        component: <Pagination />,
      },
      {
        name: "Budget",
        route: "/strategybudgetsadmin",
        component: <Pagination />,
      },
      {
        name: "Kartta",
        route: "/strategymapsadmin",
        component: <Pagination />,
      },
      {
        name: "Painopisteet",
        route: "/strategyfocusareasadmin",
        component: <Pagination />,
      },
      {
        name: "SWOT",
        route: "/strategyswotsadmin",
        component: <Pagination />,
      },
      {
        name: "Osmo strategia",
        route: "/osmostrategy",
        component: <Pagination />,
      },
      {
        name: "IDecide",
        route: "/idecide",
        component: <Pagination />,
      },
    ],
  },
];

export default routes;
/**
 * {
    name: "Kunnat",
    icon: <LocationCityRounded />,
    description: "Kunta",
    route: "/municipalities",
    component: <Municipalities />,
  },
 */
